import React, { useCallback } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import RadioButton from 'design-system/RadioButton';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { isWeb } from '../../../../constants';
const KeyboardSettingsRow = ({ title, subTitle, onPress, filter, activeSettingsFilter }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const handlePress = useCallback(() => {
        onPress(filter);
    }, [filter, onPress]);
    return (<TouchableHighlight onCard hoverOnLight activeOpacity={1} onPress={handlePress} underlayColor={colors.background.underlay}>
      <View style={styles.container}>
        <RadioButton type="single" isChecked={filter === activeSettingsFilter}/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16>{title}</Text>
          <Text TextThin-14 Secondary>
            {subTitle}
          </Text>
        </View>
      </View>
    </TouchableHighlight>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb && {
            paddingHorizontal: 8,
        }),
    },
    flex: {
        flex: 1,
    },
}));
export default KeyboardSettingsRow;
